import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();
  const headers = t('comparison.headers', { returnObjects: true }) as string[];
  const rows = t('comparison.rows', { returnObjects: true }) as Array<{
    label: string;
    spreadsheet: string;
    manual: string;
  }>;

  const getCellClass = (value: string) => {
    if (value.includes('★')) {
      return value.length >= 3 ? 'text-accent-600 font-semibold' : 'text-foreground-400';
    }
    return value === 'Tak' ? 'text-accent-600 font-semibold' : 'text-foreground-400';
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-12">
          {t('comparison.title')}
        </h2>

        <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/70 bg-secondary-50">
                  {headers.map((h, i) => (
                    <th
                      key={i}
                      className={`px-5 py-3.5 font-semibold text-foreground-700 text-xs uppercase tracking-wide ${
                        i === 0 ? 'text-left' : 'text-center'
                      }`}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr
                    key={idx}
                    className={`border-b border-background-200/50 ${
                      idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                    }`}
                  >
                    <td className="px-5 py-3.5 text-foreground-800 font-medium">{row.label}</td>
                    <td className={`px-5 py-3.5 text-center ${getCellClass(row.spreadsheet)}`}>
                      {row.spreadsheet}
                    </td>
                    <td className={`px-5 py-3.5 text-center ${getCellClass(row.manual)}`}>
                      {row.manual}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}